import { CurrencyPipe, DatePipe } from "@angular/common";
import { DomSanitizer } from "@angular/platform-browser";

import { EnderecoUtil } from "src/app/homecare/gis/endereco/endereco-util";
import { IEndereco } from "src/app/homecare/gis/endereco/endereco.interface";
import { ButtonType } from "../../enums/buttontype.enum";
import { DataType } from "../../enums/datatype.enum";
import { Metadata } from "../../list/metadata/metadata.component";
import { Status } from "../default.model";
import { JsonUtil } from "../utils/json-util";


export class ResultsetPipeUtil {

  private corDeFundoPar = '#7fe0aa';
  private corDeFundoImpar = '#cee4f7';
  private corDaBordaPar = '#3abb50';
  private corDaBordaImpar = '#94c0de';

  private enderecoUtil: EnderecoUtil = null;

  constructor(
    private datePipe: DatePipe,
    private domSanitizer: DomSanitizer,
    private currencyPipe: CurrencyPipe
  ){
    this.enderecoUtil = new EnderecoUtil();
  }

  toggleList(metadata: Metadata, valorCelula: string, rowIndex: number, valorCelulasTabelaInteira: any): string {
    if ( Array.isArray(valorCelula) ) {
      let valorRetorno = '';
      let i = 0;
      let bgColor;
      let borderColor;

      const filhosMetadata: Metadata[] = metadata.filhos;
      for ( const valor of valorCelula ) {
        if ( i % 2 === 0 ) {
          bgColor = this.corDeFundoPar;
          borderColor = this.corDaBordaPar;
        }
        else {
          bgColor = this.corDeFundoImpar;
          borderColor = this.corDaBordaImpar;
        }

        valorRetorno += `
        <div style='background-color: ${bgColor};
                    border:1px solid ${borderColor};
                    padding: 8px;
                    margin: 8px 0px;'>
          ${this.getValorDaCelulaEmMultiplosMetadatas(filhosMetadata, valor, rowIndex, valorCelulasTabelaInteira)}
        </div>`;

        i++;
      }

      return valorRetorno;
    }

    return null;
  }

  getValorDaCelulaEmMultiplosMetadatas(metadatas: Metadata[], valorCelula: string, rowIndex: number, valorCelulas: any): string {
    let valorRetorno = '';
    let i = 0;
    let podeNaoExistir = false;

    for (i = 0; i < metadatas.length; i++) {
        let _valorFilho = this.procurarValorDoAtributo(metadatas[i].fieldId, valorCelula);

        // tratar valor nao encontrado (null no JSON) ou fieldId nao encontrado
        if (_valorFilho === null) {
            _valorFilho = '';
        }
        else if (_valorFilho === undefined) {
            if ( metadatas[i].podeNaoExistir ) {
              podeNaoExistir = true;
            }
            else {
              podeNaoExistir = false;
              _valorFilho = '<font color=red>verifique o atributo: ' + metadatas[i].fieldId + '</font>';
            }
        }
        else {
            _valorFilho = this.tratarDadoPeloDataType(metadatas[i], _valorFilho, rowIndex, valorCelulas);
        }

        if (valorRetorno) {
            valorRetorno += '<br>';
        }

        if ( _valorFilho ) {
          valorRetorno += ( metadatas[i].fieldName ? '<label class="texto-cinza">' + metadatas[i].fieldName + '</label>: ' : '' );
          valorRetorno += _valorFilho;
        }
        else {
          if ( metadatas[i].podeNaoExistir ) {
            valorRetorno += ( metadatas[i].fieldName ? '<label class="texto-cinza">' + metadatas[i].fieldName + '</label>: ' : '' );
          }
          else {
            valorRetorno += '<font color=red>verifique o atributo: ' + metadatas[i].fieldId + '</font>';
          }
        }
    }
    return '<div style="display:inline-block;">' + valorRetorno + '</div>';
  }

  procurarValorDoAtributo(fieldId: string, valorCelula: any): string {
    if (!fieldId) {
        return null;
    }

    const percorrerPropriedades = fieldId.indexOf('.') > -1;
    if (percorrerPropriedades) {

        const atributo: string[] = fieldId.split('.');
        let valorCelulaTemp = valorCelula;

        for (let i = 0; i < atributo.length; i++) {
            if (valorCelulaTemp) {
                valorCelulaTemp = valorCelulaTemp[atributo[i]];

                // ultima propriedade => retornar valor
                if (i === atributo.length - 1) {
                    return valorCelulaTemp;
                }
            }
            else {
                return valorCelulaTemp;
            }
        }
    }
    else {
        return valorCelula[fieldId];
    }
    return null;
  }



  procurarValorDoAtributoComFilhos(metadata: Metadata, valorCelula: string, rowIndex: number, valorCelulas: any): string | any {

    const filhosMetadata: Metadata[] = metadata.filhos;

    let valorRetorno = this.toggleList(metadata, valorCelula, rowIndex, valorCelulas);
    if ( valorRetorno ) {
      return this.domSanitizer.bypassSecurityTrustHtml(valorRetorno);
    }

    if (filhosMetadata && valorCelula) {
      return this.getValorDaCelulaEmMultiplosMetadatas(filhosMetadata, valorCelula, rowIndex, valorCelulas)
    }
    else if (valorCelula) {
      if ( JsonUtil.isJSON( valorCelula ) ) {
        return JSON.stringify(valorCelula);
      }
      else {
        return valorCelula;
      }
    }
    else {
        return '';
    }
  }

  private stripHtml(html): string {
    if ( html ) {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    }

    return html;
  }

  tratarDadoPeloDataType(metadata: Metadata,
                        valorRetorno: any,
                        rowIndex: number,
                        valorCelulas: any): any {
    switch (metadata.dataType) {
        case DataType.NUMBER:
        case DataType.DECIMAL:
          break;

        case DataType.TEXT:
          valorRetorno = this.stripHtml(valorRetorno);
          break;

        case DataType.CURRENCY:
          valorRetorno = this.currencyPipe.transform(valorRetorno, 'R$ ');
          break;

        case DataType.DATE:
          valorRetorno = this.datePipe.transform(valorRetorno, 'dd/MM/yyyy');
          break;

        case DataType.DATETIME:
          valorRetorno = this.datePipe.transform(valorRetorno, 'dd/MM/yyyy HH:mm:ss');
          break;

        case DataType.TIME:
          valorRetorno = this.datePipe.transform(valorRetorno, 'HH:mm:ss');
          break;

        case DataType.BUTTON:
          valorRetorno = this.construirBotao(metadata);
          valorRetorno = this.domSanitizer.bypassSecurityTrustHtml(valorRetorno);
          break;

        case DataType.OBJECT:
          valorRetorno = this.procurarValorDoAtributoComFilhos(metadata, valorRetorno, rowIndex, valorCelulas);
          break;

        case DataType.CHECKBOX:
          valorRetorno = this.construirCheckbox(metadata, rowIndex, valorCelulas);
          valorRetorno = this.domSanitizer.bypassSecurityTrustHtml(valorRetorno);
          break;

        case DataType.HTML:
          valorRetorno = this.domSanitizer.bypassSecurityTrustHtml(valorRetorno);
          break;

        case DataType.ADDRESS:
          valorRetorno = this.construirEndereco(valorRetorno);
          break;

        case DataType.TAG_ON_OFF:
          valorRetorno = this.construirHtmlOnOff(valorRetorno);
          break;

        case DataType.SWITCH:
          valorRetorno = this.construirHtmlSwitch(metadata, rowIndex, valorRetorno);
          valorRetorno = this.domSanitizer.bypassSecurityTrustHtml(valorRetorno);
          break;

        default:
            break;
    }
    return valorRetorno;
  }

  construirHtmlOnOff(valorRetorno: any): string {
    return ( valorRetorno ? '<label class="tag tag-success lista-tag">LIGADO</label>' : '<label class="tag lista-tag">DESLIGADO</label>' );
  }

  construirHtmlSwitch(metadata: Metadata, rowIndex: number, valorRetorno: any): string {
    const title = metadata.title ? metadata.title.replace(/'/g, '`') : '';
    const isAtivo = (valorRetorno && valorRetorno === Status.ATIVO)
    let o  =  `<input type='checkbox'
                        name='switch__${metadata.fieldId}_${rowIndex}'
                        id='switch__${metadata.fieldId}_${rowIndex}'
                        ${( isAtivo ? 'checked' : '' )}
                        class='lista-switch-input' title='${title}' />`;

    o += `<label class='lista-switch-label' for='switch__${metadata.fieldId}_${rowIndex}'>
      ${ isAtivo ? 'Ativo' : 'Inativo' }
      </label>`;

    return o;
  }

  construirCheckbox(metadata: Metadata, rowIndex: number, valorCelulas: any): any {
    const selecionado = valorCelulas[metadata.fieldId];

    const value = JSON.stringify(valorCelulas).replace(/'/g, '`');

    const title = metadata.title ? metadata.title.replace(/'/g, '`') : '';

    const o  =  `<input type='checkbox'
                        name='cb__${metadata.fieldId}'
                        id='cb__${metadata.fieldId}_${rowIndex}'
                        value='${value}'
                        ${( selecionado ? 'checked' : '' )}
                        class='lista-checkbox' title='${title}' />`;

    return o;
  }

  construirBotao(metadata: Metadata): any {
      let valorRetorno: any;
      if (metadata.buttonType !== null) {
        switch (metadata.buttonType) {
          case ButtonType.EXCLUIR:
            metadata.mat_icon = 'delete';
            if ( !metadata.title ) { metadata.title = 'Remover...' }
            break;

          case ButtonType.EDITAR:
            metadata.mat_icon = 'edit';
            if ( !metadata.title ) { metadata.title = 'Editar...' }
            break;

          case ButtonType.DOWNLOAD:
            metadata.mat_icon = 'get_app';
            if ( !metadata.title ) { metadata.title = 'Download...' }
            break;

          case ButtonType.LIST:
            metadata.mat_icon = 'list';
            if ( !metadata.title ) { metadata.title = 'Listar...' }
            break;

          case ButtonType.POPUP:
            metadata.mat_icon = 'open_in_new';
            if ( !metadata.title ) { metadata.title = 'Abrir...' }
            break;

          case ButtonType.INFO:
            metadata.mat_icon = 'info_outline';
            if ( !metadata.title ) { metadata.title = 'Informações...' }
            break;

          case ButtonType.START:
            metadata.mat_icon = 'play_arrow';
            if ( !metadata.title ) { metadata.title = 'Iniciar...' }
            break;

          case ButtonType.MOVER_ACIMA:
            metadata.mat_icon = 'arrow_upward';
            if ( !metadata.title ) { metadata.title = 'Mover para cima...' }
            break;

          case ButtonType.MOVER_ABAIXO:
            metadata.mat_icon = 'arrow_downward';
            if ( !metadata.title ) { metadata.title = 'Mover para baixo...' }
            break;

          case ButtonType.PRANCHETA:
            metadata.mat_icon = 'assignment';
            if ( !metadata.title ) { metadata.title = 'Abrir...' }
            break;

          case ButtonType.DOUBLE_ARROW:
            metadata.mat_icon = 'double_arrow';
            if ( !metadata.title ) { metadata.title = 'Enviar...' }
            break;

          default:
              break;
        }

        if ( metadata.disabled ) {
          metadata.title = 'Indisponível...'
        }
      }

      const disableClass = metadata.disabled ? 'resultset-btn-disabled' : 'resultset-btn-enable';

      if (metadata.fa_icon) {
          valorRetorno = `<i pButton class="${metadata.fa_icon} ${disableClass}" title="${metadata.title}"></i>`;
      }
      if (metadata.mat_icon) {
          valorRetorno = `<i pButton class="material-icons  ${disableClass}" title="${metadata.title}">${metadata.mat_icon}</i>`;
      }
      return valorRetorno;
  }

  construirEndereco(valor: IEndereco): any {
    return this.enderecoUtil.getEnderecoEstilizado(valor, null);
  }

}
